<mat-toolbar class="topbar horizontal-topbar">
  <div class="container horizontal-header ">
    <div class="d-none d-sm-flex">
<!--      <app-branding></app-branding>-->
    </div>

    <!-- Mobile Menu -->
    <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-block d-lg-none">
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
    <!-- --------------------------------------------------------------- -->

    <!-- --------------------------------------------------------------- -->
    <!--  Search -->
    <!-- --------------------------------------------------------------- -->
<!--    <button mat-icon-button (click)="openDialog()" class="d-flex">-->
<!--      <i-tabler name="search" class="icon-20 d-flex"></i-tabler>-->
<!--    </button>-->


      <span class="flex-1-auto "></span>
      <form *ngIf="isSearchPage" class="custom-form-field">
          <input type="text" autocomplete="off" placeholder="Search Users" [formControl]="searchParam" (keydown.enter)="activateSearch(); $event.preventDefault();"  style="width: 260px; padding-left: 5px">
          <mat-icon type="submit" color="primary" matSuffix (click)="activateSearch()">search</mat-icon>
      </form>




    <span class="flex-1-auto"></span>

    <div class="d-flex cursor-pointer flex-wrap">
      <h1 class="f-s-14 f-w-600 m-r-8 p-r-8 b-r-1">Available Balance: {{ userData.BALANCE | number: "1.2-2"}}</h1>
      <h1 class="f-s-14 f-w-600 m-0">Welcome,{{userData.NAME}}</h1>
    </div>

    <div [matMenuTriggerFor]="profilemenu" class="p-y-12 p-x-12 cursor-pointer">
      <mat-icon color="primary" class="custom-icon">account_circle</mat-icon>
<!--      <img src="/assets/images/profile/user-1.jpg" class="rounded-circle object-cover" width="35" />-->
<!--      <button (click)="logOut()" mat-raised-button color="primary" class="fetch-button">Log Out</button>-->
    </div>

    <mat-menu #profilemenu="matMenu" xPosition="before" class="topbar-dd cardWithShadow p-20">
      <div class="p-x-16">
        <h6 class="f-s-16 f-w-600 m-0">User Profile</h6>

        <div class="d-flex align-items-center p-b-12 b-b-1 m-t-16">
            <span class="f-s-14 d-block m-b-4">{{userData.ROLE_NAME}}</span>
        </div>
      </div>
      <div class="p-x-10">
        @for(profile of profiledd; track profile) {
        <a class="p-y-16 text-decoration-none d-block text-hover-primary" [routerLink]="['home/my-account']">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-white bg-light-success shadow-none rounded">
              <mat-icon color="primary">person</mat-icon>
            </button>

            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                {{ profile.title }}
              </h5>
              <span class="mat-body-1">{{ profile.subtitle }}</span>
            </div>
          </div>
        </a>
        }
      </div>

      <div class="p-x-10">
        <a class="text-decoration-none d-block text-hover-primary" (click)="logOut()" >
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light-success shadow-none rounded">

              <mat-icon color="primary">logout</mat-icon>
            </button>

            <div class="m-l-16">
              <a class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text cursor-pointer">
                Log Out
              </a>
            </div>
          </div>
        </a>
      </div>

    </mat-menu>
  </div>
</mat-toolbar>
